import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'referencingSourcesLabel'
	| 'viewSourcesLabel'
	| 'zeroSourcesTitle'
	| 'zeroSourcesDescription'
	| 'zeroSourcesDismissLabel';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description: string }
> = defineMessages({
	referencingSourcesLabel: {
		id: 'conversation-assistant-chat-prompt-input.space-context-banner.referencing-sources-label',
		defaultMessage: 'Referencing {count, plural, one {# source} other {# sources}}',
		description:
			'Label shown above the chat prompt input when the user is in a Rovo Space-scoped conversation. Indicates how many sources from the space the assistant will reference. Pluralises source/sources based on count.',
	},
	viewSourcesLabel: {
		id: 'conversation-assistant-chat-prompt-input.chat-prompt-input.space-context-banner.view-sources-label',
		defaultMessage: 'View {count, plural, one {# source} other {# sources}}',
		description:
			'Accessible label for the space context banner trigger that opens the list of sources associated with the current Rovo Space.',
	},
	zeroSourcesTitle: {
		id: 'conversation-assistant-chat-prompt-input.space-context-banner.zero-sources-title',
		defaultMessage: 'Add sources to your space',
		description:
			'Heading for a banner above the chat prompt input shown when a Rovo Space has no sources.',
	},
	zeroSourcesDescription: {
		id: 'conversation-assistant-chat-prompt-input.space-context-banner.zero-sources-description',
		defaultMessage:
			"This space doesn't have sources yet. Get more relevant answers — add Confluence pages, Jira projects, or other sources to this Space.",
		description:
			'Body text for a banner above the chat prompt input shown when a Rovo Space has no sources, explaining why adding sources is useful.',
	},
	zeroSourcesDismissLabel: {
		id: 'conversation-assistant-chat-prompt-input.space-context-banner.zero-sources-dismiss-label',
		defaultMessage: 'Dismiss',
		description:
			'Label for the button that dismisses the zero sources banner above the Rovo Space chat prompt input.',
	},
});
